<template>
  <div class="mt-2 pa-2">
    <v-layout align-end class="subheading">
      <img class="c-align-self-start" src="@/assets/img/illustrations/production.png" alt="cardboard box" width="36px">
      <span class="font-weight-bold text-uppercase">
        {{ item.definition.name }}
      </span>
    </v-layout>
    <v-layout>
      <v-flex xs3 class="ma-1">
        <div class="label">
          Expected quantity
        </div>
        <div class="answer">
          {{ item.quantity }}
        </div>
        <div class="border-b"></div>
      </v-flex>
      <v-flex xs3 class="ma-1">
        <div class="label">
          Final yield
        </div>
        <div class="answer">
          <input type="text" style="width: 100%;">
        </div>
        <div class="border-b"></div>
      </v-flex>
      <v-flex xs3 class="ma-1">
        <div class="label">
          Batch number
        </div>
        <div class="answer">
          {{ item.batch_number }}
        </div>
        <div class="border-b"></div>
      </v-flex>
      <v-flex xs3 class="ma-1">
        <div class="label">
          Expiry date
        </div>
        <div class="answer">
          {{ expiryDate }}
        </div>
        <div class="border-b"></div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    expiryDate () {
      return this.$moment(this.item.expiry_date).isValid() ? this.$moment(this.item.expiry_date).format('D MMMM YYYY') : ''
    }
  }
}
</script>

<style scoped>
.answer {
  font-weight: bold;
  height: 1.8rem;
  font-size: 1.2rem;
}
.border-b {
  border-bottom: 1px solid var(--v-hline-base);
}
</style>
